import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

import { InterstitialModal } from './interstitial.interface';

@Injectable()
export class InterstitialService {
    private interstitialData = new Subject<any>();
    private interstitialModal: InterstitialModal;


    constructor() { }

    getInterstitialData(): Observable<any> {
        return this.interstitialData.asObservable();
    }

    setInterstitialData(interstitialData: InterstitialModal) {
        this.interstitialModal = interstitialData;
        this.interstitialData.next(this.interstitialModal);
    }
}
